import { render, staticRenderFns } from "./ResellerPaymentViewGlobal.vue?vue&type=template&id=4c09cd24"
import script from "./ResellerPaymentViewGlobal.vue?vue&type=script&lang=js"
export * from "./ResellerPaymentViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports